/* Offentlige, nøkkelfrie oppslag: Kartverkets Geonorge og Brønnøysundregistrene. */

export interface AddressHit {
  tekst: string;
  postnr: string;
  poststed: string;
  kommune: string;
  knr: string;
  gnr: string;
  bnr: string;
  lat: number | null;
  lon: number | null;
}

interface GeonorgeAddress {
  adressetekst?: string;
  adressenavn?: string;
  postnummer?: string;
  poststed?: string;
  kommunenavn?: string;
  kommunenummer?: string;
  gardsnummer?: number | string;
  bruksnummer?: number | string;
  representasjonspunkt?: { lat?: number; lon?: number };
}

export async function searchAddress(query: string, signal?: AbortSignal): Promise<AddressHit[]> {
  const url = new URL('https://ws.geonorge.no/adresser/v1/sok');
  url.searchParams.set('sok', query);
  url.searchParams.set('treffPerSide', '6');
  url.searchParams.set('asciiKompatibel', 'true');

  const response = await fetch(url, signal ? { signal } : {});
  if (!response.ok) throw new Error(`Geonorge svarte ${response.status}`);

  const body = (await response.json()) as { adresser?: GeonorgeAddress[] };
  return (body.adresser ?? []).map((address) => ({
    tekst: address.adressetekst ?? address.adressenavn ?? '',
    postnr: address.postnummer ?? '',
    poststed: address.poststed ?? '',
    kommune: address.kommunenavn ?? '',
    knr: address.kommunenummer ?? '',
    gnr: String(address.gardsnummer ?? ''),
    bnr: String(address.bruksnummer ?? ''),
    lat: address.representasjonspunkt?.lat ?? null,
    lon: address.representasjonspunkt?.lon ?? null,
  }));
}

export interface CompanyHit {
  navn: string;
  organisasjonsform?: { beskrivelse?: string };
  forretningsadresse?: { adresse?: string[]; postnummer?: string; poststed?: string };
  konkurs?: boolean;
}

export async function lookupCompany(orgnr: string): Promise<CompanyHit> {
  const clean = orgnr.replace(/\D/g, '');
  if (!/^\d{9}$/.test(clean)) throw new Error('Orgnummer må være 9 siffer.');

  const response = await fetch(`https://data.brreg.no/enhetsregisteret/api/enheter/${clean}`);
  if (response.status === 404) throw new Error('Fant ikke orgnummeret i Enhetsregisteret.');
  if (!response.ok) throw new Error(`Brreg svarte ${response.status}`);

  return (await response.json()) as CompanyHit;
}

export function formatCompanyAddress(company: CompanyHit): string {
  const address = company.forretningsadresse;
  if (!address) return '';
  return `${address.adresse?.join(' ') ?? ''}, ${address.postnummer ?? ''} ${address.poststed ?? ''}`.trim();
}
